import { useContext } from 'react'
import {
  CustomisationContextType,
  CustomisationContext,
} from '../context/CustomisationContext'

export const useCustomisation = (): CustomisationContextType => {
  const context = useContext(CustomisationContext)
  if (context === undefined) {
    throw new Error(
      'useCustomisation must be used within a CustomisationProvider'
    )
  }

  return context
}
